import { RoomV2Entity, RoomV2EntityRaw } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomUpdateResponseDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomUpdateResponseDTO.validationSchema()
  );

  constructor(readonly data: RoomUpdateResponseDTORaw) {
    JsonSchemaValidator.assert(RoomUpdateResponseDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["room"],
      properties: {
        room: RoomV2Entity.schema()
      },
      additionalProperties: false
    };
  }
}

export interface RoomUpdateResponseDTORaw {
  room: RoomV2EntityRaw;
}
